import {
  Container,
  Grid,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  getMarginWalletList,
  getSpotWalletList,
} from "store/slices/wallet/walletSlice";
import {
  getMarketLoggedInForm,
  getSingleMarketLoggedInList,
} from "store/slices/market/marketSlice";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import AdvancedTradeChart from "./Components/AdvancedTradeChart";
import AdvancedTradeForm from "./Components/AdvancedTradeForm";
import AdvancedTradeMarket from "./Components/AdvancedTradeMarket";
import AdvancedTradeWallet from "./Components/AdvancedTradeWallet";
import TradeHistory from "pages/BasicTrade/components/TradeHistory";
import { WALLET_TYPE } from "pages/BasicTrade/components/constants";
import { getTradeInitial } from "store/slices/trade/tradeSlice";
import useDispatch from "hooks/useDispatch";
import useIsMobileView from "hooks/useIsMobileView";
import { ROUTE_PATHS } from "routes/paths";

let getSingleMarketLoggedInListInterval;

function AdvancedTrade() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMdView = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobileView = useIsMobileView();

  const [formKey, setFormKey] = useState(1);

  const dispatch = useDispatch();
  const { source, destination } = useParams();

  const [searchParams] = useSearchParams();
  const sideId = +searchParams.get("sideId") || 1;
  const walletTypeId = +searchParams.get("walletTypeId") || 1;
  const borrow = +searchParams.get("borrow");
  const repay = +searchParams.get("repay");
  const transfer = +searchParams.get("transfer");
  const handleGetWalletInfo = (walletTypeId) => {
    if (walletTypeId === WALLET_TYPE.spot) {
      dispatch(getSpotWalletList({ isShowMore: false }));
    } else {
      dispatch(getMarginWalletList({ isShowMore: false }));
    }
  };

  useEffect(() => {
    if (isMobileView) {
      navigate(ROUTE_PATHS.trade.basic("1", "3"));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobileView]);

  useEffect(() => {
    dispatch(getMarketLoggedInForm());

    dispatch(
      getTradeInitial({
        coinId: source,
        coinMasterId: destination,
        sideId,
        walletTypeId,
      })
    );

    dispatch(
      getSingleMarketLoggedInList({
        coinSourceId: source,
        coinDestinationId: destination,
      })
    );

    return () => {
      clearInterval(getSingleMarketLoggedInListInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source, destination]);

  useEffect(() => {
    handleGetWalletInfo(walletTypeId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [borrow, repay, transfer]);

  return (
    <Container maxWidth="100%">
      <Grid container>
        <Grid item lg={2.5} md={4}>
          <AdvancedTradeWallet handleGetWalletInfo={handleGetWalletInfo} />
        </Grid>

        <GridLeft item lg={6.5} md={8}>
          <AdvancedTradeChart />

          <AdvancedTradeForm
            key={formKey}
            handleGetWalletInfo={handleGetWalletInfo}
          />
        </GridLeft>

        {!isMdView && (
          <Grid item lg={3}>
            <AdvancedTradeMarket />
          </Grid>
        )}
      </Grid>

      <Grid container id="trade_history">
        <Grid item xs={12}>
          <TradeHistory
            onCancelOrder={() => {
              setFormKey((v) => v + 1);
              handleGetWalletInfo(walletTypeId);
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

const GridLeft = styled(Grid)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.modules.border}`,
  borderLeft: `1px solid ${theme.palette.modules.border}`,
}));

export default AdvancedTrade;
